$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
  	
  	if (scroll >= 600) {
        $(".sticky-header").addClass("green-sticky");
    } else {
        $(".sticky-header").removeClass("green-sticky");
    }
}); 

function setCookie( c_name, value, exdays ) {
	var c_value = escape(value);
	if (exdays) {
		var exdate = new Date();
		exdate.setDate( exdate.getDate() + exdays );
		c_value += '; expires=' + exdate.toUTCString();
	}
	document.cookie = c_name + '=' + c_value;
}

function getCookie( c_name ) {
	var i, x, y, cookies = document.cookie.split( ';' );

	for ( i = 0; i < cookies.length; i++ ) {
		x = cookies[i].substr( 0, cookies[i].indexOf( '=') );
		y = cookies[i].substr( cookies[i].indexOf( '=') + 1 );
		x = x.replace( /^\s+|\s+$/g, '' );

		if ( x === c_name ) {
			return unescape( y );
		}
	}
}


window.setTimeout(function(){ 
	// When the cookie exists, do not show the popup!
	if (getCookie('displayedPopupNewsletterNEEV')) {
		return;
	}

	//DiviArea.show('get-newsletter');
  	 $('.popup-wrap').fadeIn(1500);

	// The popup was displayed. Set the cookie for 1 day.
	setCookie('displayedPopupNewsletterNEEV', 'yes', 30);
}, 3000);

 $('.popup .btn-close').on("click",function(){
   $('.popup-wrap').fadeOut(500);
 });